import React, {useState, useEffect} from 'react';
import {useDispatch} from 'react-redux';
import './Ordinary/CriticalIllness.sass';
import './ProductRiders.sass';
import {Box, CircularProgress, FormControl, InputLabel, MenuItem, Select} from '@material-ui/core';
import {isLoaded, isLoading, PackageModel} from 'ApplicationEntry/models/ProductsRiders/PackageModel';
import {StringUnion} from 'Core/models/EmptyString';
import SortUtility from 'Shared/utilities/SortUtility';

type PackageSelectProps = {
  packageName: StringUnion;
  packageList: PackageModel;
  changePackageAction: (packageName: string) => void;
  handlePackageItems?: (packageItem: object) => void;
  disabled?: boolean;
  hidden?: boolean;
};

export const loadPackages = (packageList: PackageModel) => {
  if (isLoaded(packageList)) {
    const packageData = SortUtility.sortPropertiesByKey('packageName')(packageList.Data);

    return packageData.map((packageItem: object, index: any) => {
      const packageName = packageItem['packageName'];

      return (
        <MenuItem value={packageName} key={`${packageItem['packageName']}-${packageName['id']}-${index}`}>
          {packageName}
        </MenuItem>
      );
    });
  } else {
    return null;
  }
};

const PackageSelect = (props: PackageSelectProps) => {
  const dispatch = useDispatch();
  const {disabled, hidden, packageName, packageList, changePackageAction, handlePackageItems} = props;
  const [packageLabel, setPackageLabel] = useState<HTMLLabelElement | null>();
  const [handlePackageReload, setHandlePackageReload] = useState(true);

  useEffect(() => {
    if (isLoaded(packageList) && packageList.Data.length === 1 && handlePackageReload) {
      const packageData = packageList.Data;
      const packageItem = packageData[0];

      dispatch(changePackageAction(packageItem['packageName']));
      setHandlePackageReload(false);
      handlePackageItems!(packageItem!);
    } else if (isLoaded(packageList) && packageList.Data.length > 1 && !handlePackageReload) {
      setHandlePackageReload(true);
    }
  }, [changePackageAction, dispatch, packageList, handlePackageItems, handlePackageReload]);

  const component = (
    <>
      <FormControl variant="outlined" className="product-riders-section__policy-type__form__row--field">
        <InputLabel ref={setPackageLabel} id="package-select-package-label">
          Package
        </InputLabel>
        <Select
          labelId="package-select-label-package"
          labelWidth={packageLabel?.clientWidth}
          id="package-select-package"
          value={packageName.key === 'Empty' || isLoading(packageList) ? '' : packageName.value}
          onChange={event => {
            const packageItem = isLoaded(packageList)
              ? packageList.Data.find(
                  (packageItem: object) => packageItem['packageName'] === (event.target.value as string)
                )
              : null;

            dispatch(changePackageAction(event.target.value as string));

            handlePackageItems!(packageItem!);
          }}
          displayEmpty
          disabled={disabled}
        >
          {loadPackages(packageList)}
        </Select>
        {isLoading(packageList) ? (
          <CircularProgress className="product-riders-section__policy-type__loading-icon" />
        ) : null}
      </FormControl>
    </>
  );

  return hidden ? (
    <>
      <Box
        component="select"
        display={{
          xs: 'none',
          lg: 'none',
          sm: 'none',
          md: 'none',
          xl: 'none',
        }}
      >
        {component}
      </Box>
    </>
  ) : (
    component
  );
};

export default PackageSelect;
